export enum MediaStatus {
    LOADED = "LOADED",
    PLAY = "PLAY",
    PAUSE = "PAUSE",
    LIVE = "LIVE",
    LIVE_INITIALIZING = "LIVE_INITIALIZING",
}
